import defaultState from '@/store/modules/auctions/defaultState';

const actions = {
  getMyAcvWonAuctions(
    {
      dispatch,
    },
    { page = 1 },
  ) {
    return dispatch('getAuctionList', {
      apiMethod: 'getMyAcvWonAuctions',
      moduleKey: 'MyAcvWon',
      numberOfLoaders: 10,
      page,
    });
  },
};

export default {
  state: defaultState,
  actions,
};
